import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { AppError, CoreState, MarketSelector } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { REGISTRATION_WITH_IDIN_ACTION_TYPE, RegistrationWithIdinAction } from "./registration-with-idin.action";
import { RegistrationWithIdinService } from "./registration-with-idin.service";

@Injectable()
export class RegistrationWithIdinEffect {
	getIdinRegistrationUrl$ = createEffect(() =>
		this.actions$.pipe(
			ofType(REGISTRATION_WITH_IDIN_ACTION_TYPE.getIdinRegistrationUrl),
			switchMap(() =>
				this.registrationWithIdinService.getIdinRegistrationUrl().pipe(
					withLatestFrom(
						this.store.pipe(
							select(this.marketSelector.getCurrent()),
							map((currentMarket) => currentMarket.languageCode)
						)
					),
					map(([response, languageCode]) => {
						const endpointUrl = this.registrationWithIdinService.addReturnUrlParameter(
							response.endpointUri,
							languageCode
						);

						return this.action.getIdinRegistrationUrlSuccess(endpointUrl);
					}),
					catchError((response: AppError) => of(this.action.getIdinRegistrationUrlFail(response)))
				)
			)
		)
	);

	constructor(
		private store: Store<CoreState>,
		private actions$: Actions,
		private action: RegistrationWithIdinAction,
		private registrationWithIdinService: RegistrationWithIdinService,
		private marketSelector: MarketSelector
	) {}
}
